import { RefObject, useEffect, useState } from "react";
import { RouteViewMode } from "../ChangeDriverRouteView";

/**
 * Manages the viewport height for the map container
 * Updates when the route view mode changes
 */
export function useViewportHeight(
  mapContainerRef: RefObject<HTMLDivElement>,
  routeViewMode: RouteViewMode
) {
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight - 50);

  useEffect(() => {
    if (mapContainerRef.current) {
      const updatedHeight = mapContainerRef.current.offsetHeight;
      setViewportHeight(updatedHeight);
    }
  }, [routeViewMode, mapContainerRef]);

  return viewportHeight;
}

